import { fileToBase64 } from 'utils/file-utils';
import { Image } from 'api/query/shared/image';

export enum ImageUploadError {
  FileType = 'File type not supported',
  FileSize = 'File size must not exceed 5MB',
}

/**
 * Creates the `catalogueImages.images` payload for updating a catalogue.
 * @param file The image file.
 * @param id The catalogue id.
 */
export const getFilePayload = async (file: File, id: number | undefined) => {
  let images: Image[] = [];

  if (file) {
    images = [{
      catalogueId: id,
      image: {
        imageBytes: await fileToBase64(file, true),
        mimeType: file.type,
      },
    }];
  }

  return images;
};

/**
 * Gets the array of allowed catalogue image file types.
 */
export const getAllowedImageTypes = () => ['image/png', 'image/jpg', 'image/jpeg'];

/**
 * Gets the array of allowed catalogue image extensions.
 */
export const getAllowedImageExtensions = () => ['.png', '.jpg', '.jpeg'];

/**
 * Returns true if the `fileType` is a valid file as determined by existing in the `allowedTypes` array.
 * @param fileType The file mime type.
 * @param allowedTypes The allowed file mime types.
 */
export const isValidImageType = (fileType: string, allowedTypes: string[]) => allowedTypes.includes(fileType);
